import { forwardRef } from 'react';

interface ISusyTextAreaProps
    extends React.DetailedHTMLProps<
        React.TextareaHTMLAttributes<HTMLTextAreaElement>,
        HTMLTextAreaElement
    > {
    dataTestId?: string;
}

const SusyTextArea = forwardRef(
    (props: ISusyTextAreaProps, ref: React.Ref<HTMLTextAreaElement>) => {
        return (
            <textarea
                {...props}
                ref={ref}
                className={`susy-input form-control ${props.className}`}
                data-testid={props.dataTestId}
            />
        );
    }
);

SusyTextArea.displayName = 'SusyTextArea';

export default SusyTextArea;
